import { makeStyles } from '@material-ui/styles';

const MenuItem = ({ onClick, children }) => {
    const classes = useStyles();

    return (
        <div className={classes.item} onClick={onClick}>
            {children}
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        item: {
            display: 'flex',
            'flex-direction': 'row',
            'align-items': 'center',
            padding: '4px 4px 4px 6px',
            height: 26,
            'border-radius': 6,
            'align-self': 'stretch',
            margin: '6px 0px',
            cursor: 'pointer',
            color: theme.palette.greys[700],

            '&:hover': {
                background: 'rgba(64, 64, 64, 0.07)',
            },
        },
    }),
    { classNamePrefix: MenuItem.name }
);

export default MenuItem;
